module.exports = __webpack_public_path__ + "img/horizontal_7_3_3016.387e8993.png";